module.exports = __webpack_public_path__ + "img/icon_post_black.4a6dc7c8.svg";